<template>
    <div>
        <div class="journal-article-wrapper" :class="showRoute">
            <div class="page-narrow-width">
                <span class=" show-slug journal-article"><router-link class="sans-serif uppercase letter-space2" :to="'/journal'">journal</router-link></span>
                <h1 class="journal-article">{{ journal.title }}</h1> 
                  
                <div class="journal-article meta ">
                    <span style="display: block"><em style="text-transform: lowercase; font-size: 0.8em;">by</em> {{ journal.author }}</span>  
                    <span>{{  formatDate(journal.date) }}</span>
                    <strong style="padding: 0 10px;">&#8226;</strong>
                    <span>{{ calculateReadingTime(journal.content) }} MIN READ</span>
                </div>
            </div>

            <article class="width-viewport">
                <section v-html="journal.content"></section>
            </article>

            <div class="page-grid-fix background-img" :style="{  backgroundImage: 'url(http://' + this.url + '/uploads/images/2021-06-23_Ninety_at_Thom_Sweeney_240_membership.jpg)'}">
                <article class="grid-container columns-one transparent large-gap wht-txt">
                    <section class="section1 transparent wht-txt">
                        <div>
                            <h4 style="padding-bottom: 30px;">Membership</h4>
                            <div class="wht-txt">Our members will have access to a luxury personalised service, offering direct contact
                                with our team of specialists at all times. Whether looking to source an unusual piece,
                                design something special, or simply for advice on a purchase, our members will be able
                                to rely on our knowledge and expertise.</div>
                            <button type="submit">
                                <!-- <router-link class="black-a" :to="'/membership'">Discover more</router-link> -->
                                 <router-link :to="'/membership'">Discover more</router-link>
                            </button>
                            <div class="space-helper"></div>
                        </div>
                    </section>
                </article>
            </div>
        </div>

<!-- Journals -->
        <div class="space-helper" style="margin-bottom: 50px;"></div>
        <article class="grid-container rows-two regular-gap" style="padding: 39px 0;">
            <section class="section1">
                <h2>You may also like</h2>
                <span class="buttons-inline columns-two-mobile" style="float: right; line-height: 4;">
                    <button type="submit" class="clean-link" style="padding-right: 0;">
                        <router-link to="/journal">All articles</router-link>
                    </button>
                </span>
            </section>
        </article>
        <article class="journal-index">  
            <section v-for="(journal, index) in journals" :key="journal.id" :class="'section-' + ((index % 10) + 1)">
                <router-link :to="'/journal/' + journal.slug">
                <img :src="'/' + journal.index_page_image">
                <div class="excerpt-wrapper">
                    <h3>{{ journal.title }}</h3>
                    <div class="meta ">
                    <span>{{ formatDate(journal.date) }}</span>
                    <strong style="padding: 0 10px;">&#8226;</strong>
                    <span>{{ calculateReadingTime(journal.content) }} MIN READ</span>
                    </div>
                </div>
                <div class="shade"></div>
                </router-link>
            </section>
        </article>
    </div>
</template>

<script>
export default {
    name: 'JournalArticle',
    data() {
        return {
           journal: [],
           journals: [],
           url: '',
           showRoute: null, // Initialize as null
        };
    },
    
    watch: {
        '$route.name': function (newRouteName) {
          this.showRoute = newRouteName;
          // Optionally, if the route change requires fetching new data:
          this.getJournals();
        },    
    },
    
    created() {
        this.showRoute = this.$route.name;
        this.getJournals(); // Call getJournals to fetch the data
        this.$axios.get("/api/journals").then(response => { 
            this.journals = response.data;                
        });
    },
    
    mounted() {
        this.url = window.location.hostname;
    },
    
    methods: {
        getJournals() { // No address parameter needed
            const slug = this.$route.params.slug;
            if (slug) { // Check if slug exists
                this.$axios.get('/api/journalarticle/' + slug).then(response => {         
                    this.journal = response.data;
                    this.$emit("route-data-ready");
                });
            } else {
                this.$emit("route-data-ready");
            }
        },
        calculateReadingTime(articleText) {
            if (!articleText) {
                return 0;
            }
            let wordCount = articleText.split(' ').length;
            let wordsPerMinute = 200;
            let readingTime = Math.ceil(wordCount / wordsPerMinute);
            return readingTime;
        },
        formatDate(dateString) {
            const date = new Date(dateString)
            return date.toLocaleString('default', { month: 'long', year: 'numeric' })
        },
    },
};
</script>
